import { CreateCabinetRequestDto } from '../../../dto/cabinets/createCabinet/createCabinet.request.dto'
import { ClientCabinetType } from '../../../enums/cabinetTypes'

export const newCabinetInitialValue: CreateCabinetRequestDto = {
  bank: ClientCabinetType.SberBank,

  credentials: {
    login: "",
    password: "",
  },

  baseInfo: {
    name: "",
    birthDate: "",
    phone: "",
  },

  passport: {

  },

  feedback: {
    phoneType: "phone",
  },

  chat: {
    autoOpen: "off",
  },

  balance: {
    value: 0,
    currency: "rub",
  },
}
